export default "__VITE_ASSET__BnB0Usl3__"